import { useStaticAssetQuery } from '~/queries/UseStaticAsset.query';
import type { UseStaticAssetQueryResult } from '~/sanity/types';

type StaticAssetInfo = {
  cdnPathname: string;
  currentPathname: string;
} & UseStaticAssetQueryResult;

type StaticAssetOptions = {
  /* Adds a query to the opaque hash pathname, useful for things like requestly rules. */
  tag?: string;
};

export type { StaticAssetInfo };

export const useStaticAsset = async (
  currentPathname: string,
  options?: StaticAssetOptions
): Promise<StaticAssetInfo | null> => {
  const ops = options || {};
  const { data } = await useWwwSanityQuery<UseStaticAssetQueryResult>(useStaticAssetQuery, {
    currentPathname,
  });

  if (!data.value) {
    console.error('No static asset found for pathname:', currentPathname);
    return null;
  }
  if (!data.value.cdnKey) {
    console.error('No CDN key found for static asset:', data.value);
    return null;
  }

  const pdfRef = data.value.cdnKey;
  const bits = pdfRef.split('-');
  if (bits.length < 3) {
    console.warn('Invalid CDN file reference:', pdfRef);
    return null;
  }

  const fileName = bits[1];
  const fileExtension = bits[2];
  const cdnPathname = `/cdn-files/${fileName}.${fileExtension}`;
  const tmpUrl = new URL(cdnPathname, 'https://www.onshape.com');
  if (ops.tag) {
    tmpUrl.searchParams.set('tag', ops.tag);
  }

  return {
    ...data.value,
    cdnPathname: tmpUrl.pathname + tmpUrl.search,
    currentPathname,
  };
};
